import { escapeHtml } from "../utils/escapeHtml";

interface ConfirmOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export function confirmDialog(opts: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    const overlay = document.createElement("div");
    overlay.className = "confirm-dialog-overlay";
    overlay.innerHTML = `
      <div class="confirm-dialog">
        <h3 class="confirm-dialog-title">${escapeHtml(opts.title)}</h3>
        <p class="confirm-dialog-message">${escapeHtml(opts.message)}</p>
        <div class="confirm-dialog-actions">
          <button class="btn btn-sm confirm-dialog-cancel" type="button">${escapeHtml(opts.cancelLabel || "Cancel")}</button>
          <button class="btn btn-sm btn-primary confirm-dialog-confirm" type="button">${escapeHtml(opts.confirmLabel || "Confirm")}</button>
        </div>
      </div>
    `;
    const close = (result: boolean) => { overlay.remove(); resolve(result); };
    overlay.querySelector(".confirm-dialog-confirm")?.addEventListener("click", () => close(true));
    overlay.querySelector(".confirm-dialog-cancel")?.addEventListener("click", () => close(false));
    overlay.addEventListener("click", (e) => { if (e.target === overlay) close(false); });
    document.body.appendChild(overlay);
  });
}
